const endpoint = {
  getList: "/tms/leaves-management/annual-leaves/general-config",
  create: "/tms/leaves-management/annual-leaves/general-config/create",
  update: "/tms/leaves-management/annual-leaves/general-config/update",
  delete: "/tms/leaves-management/annual-leaves/general-config/delete",
  history: "/tms/leaves-management/annual-leaves/general-config/history",
};
import {
  ADVANCE_LEAVE_EXTRA,
  CONDITION_MONTH_EXTRA,
  LEAVE_HOURS_IN_MONTH_EXTRA,
  SENIORITY_LEAVE_YEAR_EXTRA,
} from "@/pages/AnnualLeave/constants";
import { GENERAL_CONFIG_LIST, HISTORY_GENERAL_CONFIG_LIST, SET_PAGES } from "@/store/mutation-types";
import {
  convertObjectToParams,
  DATE_FORMAT_V2_DMY_HM,
  formatDataField,
  formatDataFieldWithFixed,
  formatDateStringToString,
  PAGE_DEFAULT,
} from "@/utils";
import http from "../../helpers/httpInterceptor";

const state = () => ({
  generalConfigList: [],
  historyGeneralConfigList: [],
  pages: PAGE_DEFAULT,
});

const mutations = {
  [GENERAL_CONFIG_LIST](state, data) {
    state.generalConfigList = formatData(data);
  },
  [HISTORY_GENERAL_CONFIG_LIST](state, data) {
    state.historyGeneralConfigList = formatHistory(data);
  },
  [SET_PAGES](state, data) {
    state.pages = data;
  },
};

const actions = {
  getGeneralConfigList({ commit }, payload) {
    return http
      .get(`${endpoint.getList}${convertObjectToParams(payload)}`)
      .then((res) => {
        const {
          data,
          page: { page, size, total_element },
        } = res.data;
        commit(GENERAL_CONFIG_LIST, data ?? []);
        commit(SET_PAGES, {
          page,
          size,
          total: total_element,
        });
        return res.data;
      })
      .catch((error) => {
        commit(GENERAL_CONFIG_LIST, []);
        commit(SET_PAGES, PAGE_DEFAULT);
        throw error;
      });
  },
  createGeneralConfig(_, payload) {
    return http
      .post(endpoint.create, payload)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  updateGeneralConfig(_, payload) {
    return http
      .put(endpoint.update, payload)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  deleteGeneralConfig(_, id) {
    return http
      .delete(`${endpoint.delete}/${id}`)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        throw err;
      });
  },
  historyGeneralConfigList({ commit }, payload) {
    return http
      .get(`${endpoint.history}${convertObjectToParams(payload)}`)
      .then((res) => {
        const data = res.data.data;
        commit(HISTORY_GENERAL_CONFIG_LIST, data);
        return data;
      })
      .catch((error) => {
        throw error;
      });
  },
};

const formatData = (data) => {
  if (!data || data.length <= 0) return [];
  return data.map((item) => {
    return formatItem(item);
  });
};

const formatItem = (item) => {
  const {
    applyDate,
    expireDate,
    seniorityLeaveHour,
    seniorityLeaveYear,
    conditionalMonth,
    advanceLeave,
    leaveHourInMonth,
  } = item;
  return {
    ...item,
    extraForLoyaltyFormat: formatExtraLoyalty(seniorityLeaveHour, seniorityLeaveYear),
    conditionMonthFormat: formatDataField(conditionalMonth, CONDITION_MONTH_EXTRA),
    annualLeaveHoursInMonth: formatDataFieldWithFixed(leaveHourInMonth, LEAVE_HOURS_IN_MONTH_EXTRA),
    advanceLeaveFormat: formatDataField(advanceLeave, ADVANCE_LEAVE_EXTRA),
    applyDateFormat: formatDateStringToString(applyDate),
    expireDateFormat: formatDateStringToString(expireDate),
  };
};

const formatHistory = (data) => {
  if (!data || data.length <= 0) return [];
  return data?.map((item) => {
    const { new_record, createdDate, action } = item;
    const { createdBy, modifiedBy } = new_record;
    return {
      ...item,
      createdDateFormat: formatDateStringToString(createdDate, DATE_FORMAT_V2_DMY_HM),
      new_record: {
        ...formatItem(new_record),
        createdByName: `${createdBy?.name ?? ""} - ${createdBy?.departmentName ?? ""}`,
        createdDateFormat: formatDateStringToString(new_record?.createdDate, DATE_FORMAT_V2_DMY_HM),
        updatedBy: `${modifiedBy?.name ?? ""} - ${modifiedBy?.departmentName ?? ""}`,
        modifiedDateFormat: formatDateStringToString(new_record?.modifiedDate, DATE_FORMAT_V2_DMY_HM),
        applyDateFormat: formatDateStringToString(new_record?.applyDate),
        expireDateFormat: formatDateStringToString(new_record?.expireDate),
        action,
      },
    };
  });
};
const formatExtraLoyalty = (seniorityLeaveHour, seniorityLeaveYear) => {
  return `${formatDataField(
    Number.parseFloat(seniorityLeaveHour).toFixed(2),
    LEAVE_HOURS_IN_MONTH_EXTRA
  )} / ${formatDataField(seniorityLeaveYear, SENIORITY_LEAVE_YEAR_EXTRA)}`;
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
